<template>
    <div v-if="isOpen" class="search-window">
        <!-- PRODUCTS -->
        <div class="search-window__products">
            <div v-for="(product, idx) in products">
                <div class="search-window__products__product" v-if="product" :key="idx" @click="redirectToProduct(product?.url)">
                    <img :src="product.img" />
                    <div class="search-window__products__product__group">
                        <h3 class="search-window__products__product__group__name" :title="product.name">{{ product.name }}</h3>
                        <!-- <div class="search-window__products__product__group__description" v-html="product.description" /> -->
                    </div>
                    <div class="search-window__products__product__other">
                        <span :title="product.code">{{ product.code }}</span>
                        <!-- <p>{{ product.brand }}</p> -->
                    </div>
                </div>
            </div>
            <div v-if="products.length === 0" class="search-window__products__empty">
                <span>{{ $t('nothingFoundForYourRequest') }}</span>
            </div>
        </div>

        <transition name="fade">
            <div v-if="isLoading && isFirstLoading" class="search-window__preloader">
                <MyCirclePreloader :strokeWidth="2" :size="24" />
            </div>
            <div v-else-if="isLoading" class="search-window__blur"></div>
        </transition>

        <!-- CATEGORIES -->
        <div class="search-window__categories">
            <h3 :class="{ disabled: isCategoriesEmpty }">{{ $t('categories') }}</h3>
            <div class="search-window__categories__links">
                <NuxtLink v-for="(link, idx) in categories" :key="idx" :to="localePath(link.route)">{{ link.name }}</NuxtLink>
            </div>
        </div>
    </div>
</template>

<script>
import VueTypes, { nullable, object } from 'vue-types';
import { CategoryLink } from './../../types';

export default {
    name: 'SearchWindow',
    props: {
        isOpen: VueTypes.bool.isRequired,
        isLoading: VueTypes.bool.def(true),
        products: VueTypes.arrayOf(VueTypes.oneOfType([object, nullable])).def([]),
        categories: VueTypes.arrayOf(CategoryLink).def([])
    },
    components: {
        MyCirclePreloader: () => import('@/themes/ecaterix/components/ui/MyCirclePreloader')
    },
    computed: {
        isFirstLoading() {
            return !this.products[0];
        },
        isCategoriesEmpty() {
            return this.categories.length ? false : true;
        }
    },
    watch: {
        isOpen(newVal) {
            this.setScrollBlocker(newVal);
        }
    },
    methods: {
        redirectToProduct(url) {
            this.$router?.replace(this.localePath(`/product/${url}`));
        },
        setScrollBlocker(flag) {
            document.body.classList[flag ? 'add' : 'remove']('--blocked');
        }
    }
};
</script>

<style lang="scss">
@import '~/themes/ecaterix/assets/styles/utils.scss';
@import './styles.scss';
</style>
